import * as ng from 'angular';

interface Size {
   height: number;
   width: number;
}

export class ImgUploadModalController implements ng.IController {
   static $inject = ['$scope', '$uibModalInstance', 'settings', 'canvasUtils'];

   isEditing = false;
   isCropping = false;
   file;

   constructor(
      private $scope: ng.IScope,
      private $modal,
      private settings: Size,
      private canvasUtils
   ) { }

   onCancel() {
      this.$modal.dismiss('cancel');
   }

   onCrop() {
      const original = this.getCanvas();
      const cropped = original.cropper('getCroppedCanvas');
      const ctx = cropped.getContext('2d');
      const dst = document.createElement('canvas');

      dst.height = this.settings.height;
      dst.width = this.settings.width;

      this.isCropping = true;

      this.canvasUtils.resize(cropped, dst, () => this.$modal.close(dst.toDataURL()) );
   }

   onMove(x: number, y: number) {
      this.getCanvas().cropper('move', x, y);
   }

   onZoom(factor: number) {
      this.getCanvas().cropper('zoom', factor);
   }

   onDrawCanvas(file) {
      const canvas = this.getCanvas();
      const blob = URL.createObjectURL(file)

      canvas.cropper({
            aspectRatio: this.settings.width / this.settings.height,
            guides: true,
            center: true,
            responsive: true,
            cropBoxMovable: true,
            cropBoxResizable: true,
            dragCrop: false,
            autoCropArea: 1
         })
         .cropper('reset')
         .cropper('replace', blob)
         .cropper('enable');

      this.file = null;
      this.isEditing = true;
   }

   private getCanvas() : any {
      return ng.element(document.querySelector('#img-canvas'));
   }
}

ng.module('e360')
   .controller('ImgUploadModalController', ImgUploadModalController);
